import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export default class CustomValidator {

    static confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

        if (!control.parent || !control) {
            return null;
        }

        const password = control.parent.get('password');
        const passwordConfirm = control.parent.get('passwordConfirm');

        if (!password || !passwordConfirm) {
            return null;
        }

        if (passwordConfirm.value === '') {
            return null;
        }

        if (password.value === passwordConfirm.value) {
            return null;
        }

        return { 'passwordsNotMatching': true };
    }

    static onlyNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

        if (control.value === null || control.value === '') {
            return null;
        }

        if (control.value.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) {
            return null;
        }

        return { 'invalidNumber': true };
    }

    static maxLengthValidator(max: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            if (control.value === null || control.value === '') {
                return null;
            }

            if (control.value.toString().length <= max) {
                return null;
            }

            return { 'invalidMaxNumber': true };

        };
    }

    static limitTradingAccountValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

        if (control.value === null || control.value === '') {
            return null;
        }

        if (control.value <= 6 && control.value >= 1) {
            return null;
        }

        return { 'invalidLimitTradingAccount': true };
    }

}
